import { render, staticRenderFns } from "./formFinancialHighlights.vue?vue&type=template&id=533dc01c&scoped=true"
import script from "./formFinancialHighlights.vue?vue&type=script&lang=js"
export * from "./formFinancialHighlights.vue?vue&type=script&lang=js"
import style0 from "./formFinancialHighlights.vue?vue&type=style&index=0&id=533dc01c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533dc01c",
  null
  
)

export default component.exports